import React from 'react';
import { render } from 'react-dom';
import { logger } from 'redux-logger';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware } from 'redux';

import App from './App';
import rootSaga from './store/sagas';
import rootReducer from './store/reducers';

import './static/css/style.css';
import 'react-table-6/react-table.css';
import "./static/css/nucleo-icons.css";
import "./static/scss/black-dashboard-react.css";
import './static/css/theme.css';

// Suppress ResizeObserver errors
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = this;
    clearTimeout(tid);
    tid = setTimeout(() => callback.apply(ctx, args), delay);
  };
};

// Filter out ResizeObserver errors
const errorHandler = (event) => {
  if (event.message && event.message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    return true;
  }
};

window.addEventListener('error', errorHandler, true);

// Patch ResizeObserver to prevent the error
if (window.ResizeObserver) {
  const RO = window.ResizeObserver;
  window.ResizeObserver = function (callback) {
    return new RO(debounce(callback, 20));
  };
}

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware, logger));

sagaMiddleware.run(rootSaga);

// Export store for use in services
export { store };
render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
if (module.hot) { module.hot.accept(App); }